import {LearnCard} from "./learncard.js";

/**
 * React component that is a responsive grid for LearnCard components
 *
 * @param prop.learnitems An array of objects that is be used to populate LearnCard. Object fields are slug, title, date, author, tagline, cardImage.
 * @return JSX
 */
export function LearnCardList(props) {
    const {learnItems} = props
    return (
        <div className="cardListContainer">
            {learnItems.map((learnItem, i) =>(
             <div key={i} className="cardListColumn">
                <LearnCard
                title={learnItem.title}
                body={learnItem.body}
                link={learnItem.link}
                linkText={learnItem.linkText}
                cardImage={learnItem.cardImage}
                slug={learnItem.slug}
                wide={false}
                />
             </div>
            ))}
        </div>
    );
}
